module.exports = __webpack_public_path__ + "assets/dc125989a83852111614c06aff5f59cc.png";